module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAjCAYAAAD17ghaAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAETSURBVHgB7ZchsoMwEIb/vnkGywkqsFgsSLBY7sBBuAcWCxIkGosECRbFtLNRLenQaTZDTD7HkoFvsptNcsvz/AGD/MEwVsAKWIH/s5dpmsJxHCneti3meX6L0Tgaf2TbNlRVBSUB3/fhuq4U9zwPRVGIj78KBEEgjV3X9VRAKQUklSQJdKBcA2EYipkwJkBkWQYuLAFKRRzH4MBehlEUfSzUywSo+jmp0NKIqBipKC8T6PteilEqLhPouk40GB0oCVAHLMsSOlCugXEcxZ5gTIBomoadCpaAjlSwlyGlYhgGqKKlD9AsvG7Nv3B6HpimCcuySPHjz+i5rmtxfjjyrUZu9mYEw1gBK2D+ZrTv+x0GeQIn010Bp8/FRwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc/naver_icon.png
// module id = sVEA
// module chunks = 1